import React from "react"
import { Link } from "react-router-dom"
import { Pagination } from "react-bootstrap"
import Loader from "components/Loader"
import FilterDropdown from "components/FilterDropdown"
import GearHistoryRecordsTable from "./GearHistoryRecordsTable"

export default function GearHistoryRecords({
  readOnly,
  gearHistoryRecords,
  requesting,
  gearId,
  listMeta,
  historyPage,
  setHistoryPage,
  historyPerPage,
  setHistoryPerPage,
  setHistoryUserFilter,
  historyUserFilterName,
  historyUserFilterOptions
}) {
  return (
    <div className="card border-0 mt-3">
      <div className="card-body p-4">
        <div className="d-flex justify-content-between align-items-center">
          <h3>History</h3>
        </div>
        { !readOnly && (
          <Link
            className="btn btn-outlined-blue btn-sm"
            to={`/settings/gears/${gearId}/gear-history-record/new`}
            data-target="#newHistoryModal"
            data-toggle="modal"
            type="button">
            + New History
          </Link>
        )}
        {!requesting && listMeta && (
          <div className="d-flex flex-wrap align-items-center justify-content-between mt-3 mb-2">
            {listMeta.total_count > 0 && (
              <div className="text-muted small mb-2 mb-md-0">
                {listMeta.show_all
                  ? `Showing all ${listMeta.total_count} entries`
                  : (() => {
                    const start = (listMeta.current_page - 1) * listMeta.per_page + 1
                    const end = Math.min(listMeta.current_page * listMeta.per_page, listMeta.total_count)
                    return `Showing ${start}–${end} of ${listMeta.total_count}`
                  })()}
              </div>
            )}
            <div className="d-flex align-items-center flex-wrap">
              <div className="btn-group mr-2 mr-md-3 mb-2 mb-md-0">
                <FilterDropdown
                  title="User"
                  filteredName={historyUserFilterName}
                  setFilter={setHistoryUserFilter}
                  options={historyUserFilterOptions} />
              </div>
              <label className="mr-2 mb-0 text-muted small" htmlFor="gear-history-per-page">Rows per page</label>
              <select
                id="gear-history-per-page"
                className="custom-select custom-select-sm mr-md-3 mb-2 mb-md-0"
                style={{ width: "auto" }}
                value={historyPerPage}
                onChange={e => {
                  setHistoryPerPage(e.target.value)
                  setHistoryPage(1)
                }}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="all">Show all</option>
              </select>
              {!listMeta.show_all && listMeta.total_pages > 1 && (
                <Pagination className="mb-0">
                  <Pagination.Prev
                    disabled={listMeta.current_page <= 1}
                    onClick={() => setHistoryPage(Math.max(1, listMeta.current_page - 1))} />
                  <Pagination.Item disabled>
                    {listMeta.current_page}
                    {" "}
                    /
                    {listMeta.total_pages}
                  </Pagination.Item>
                  <Pagination.Next
                    disabled={listMeta.current_page >= listMeta.total_pages}
                    onClick={() => setHistoryPage(listMeta.current_page + 1)} />
                </Pagination>
              )}
            </div>
          </div>
        )}
        {requesting ? <Loader /> : <GearHistoryRecordsTable gear_history_records={gearHistoryRecords} />}
      </div>
    </div>
  )
}
